/**
 * Khung chờ (skeleton) cho vùng nội dung bên phải.
 *
 * Hiện trong tích tắc lúc mã nguồn trang mới đang được tải về, giữ đúng bố cục
 * để trang không bị nhảy và menu bên trái vẫn đứng yên.
 */
export default function PageSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div className="space-y-2">
          <div className="h-7 w-44 rounded-lg bg-background-200/80" />
          <div className="h-3.5 w-56 rounded-md bg-background-200/60" />
        </div>
        <div className="h-9 w-40 rounded-lg bg-background-200/70" />
      </div>

      <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className="h-24 rounded-lg border border-background-200 bg-background-100"
          />
        ))}
      </div>

      <div className="mt-4 rounded-lg border border-background-200 bg-white p-4">
        <div className="mb-4 h-4 w-40 rounded-md bg-background-200/70" />
        <div className="space-y-2.5">
          {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="h-3.5 flex-1 rounded-md bg-background-100" />
              <div className="h-3.5 w-20 rounded-md bg-background-100" />
              <div className="hidden h-3.5 w-14 rounded-md bg-background-100 sm:block" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}